import React from "react";
import Select from "react-select";
import { connect } from "react-redux";
import type { Dispatch } from "redux";
import { translate } from "@/modules/shared/IntlProviderWrapper";

import { PLANNING_EXPLANATION_TYPE } from "@/lib/ManufacturingConsts.generated";
import { SET_PLANNING_RESULT_TYPE, RESET_FILTERS } from "@/modules/pg/shared/planningTable/reducers/filters/filters";

import type {
    SetPlanningResultTypeAction,
    ResetFiltersAction,
} from "@/modules/pg/shared/planningTable/reducers/filters/filters";
import type { ReduxState } from "@/modules/pg/shared/planningTable/reducers/reducers";

export type SelectOptionItem = {
    label: string;
    value: string;
};

type ActionTypes = SetPlanningResultTypeAction | ResetFiltersAction;
type OwnProps = {};
type Props = OwnProps & ReduxProps;

const FILTER_PLANNING_RESULT_TYPES: SelectOptionItem[] = [
    {
        value: PLANNING_EXPLANATION_TYPE.frozen,
        label: translate("Manufacturing.Planning.Explanation.filter_frozen", "Frozen"),
    },
    {
        value: PLANNING_EXPLANATION_TYPE.missing_input_material,
        label: translate("Manufacturing.Planning.Explanation.filter_missing_input_material", "Missing input material"),
    },
    {
        value: PLANNING_EXPLANATION_TYPE.no_resource_available,
        label: translate("Manufacturing.Planning.Explanation.filter_no_resource_available", "No resource available"),
    },
    {
        value: PLANNING_EXPLANATION_TYPE.not_planned,
        label: translate("Manufacturing.Planning.Explanation.filter_not_planned", "Not planned"),
    },
    {
        value: PLANNING_EXPLANATION_TYPE.not_reached,
        label: translate("Manufacturing.Planning.Explanation.filter_not_reached", "Not reached"),
    },
    {
        value: PLANNING_EXPLANATION_TYPE.previous_operation_not_scheduled,
        label: translate(
            "Manufacturing.Planning.Explanation.filter_previous_operation_not_scheduled",
            "Previous operation not scheduled"
        ),
    },
    {
        value: "offset_material_external_id",
        label: translate("Manufacturing.Planning.Explanation.filter_offset_material", "Offset material"),
    },
    {
        value: "offset_previous_operation",
        label: translate("Manufacturing.Planning.Explanation.filter_offset_operation", "Offset operation"),
    },
];

class PlanningResultFilter extends React.Component<Props> {
    getOptions = (): SelectOptionItem[] => {
        return FILTER_PLANNING_RESULT_TYPES;
    };

    getSelectedOption = (planning_result_type: string | null): SelectOptionItem | null => {
        if (planning_result_type === null) {
            return null;
        }
        const option = FILTER_PLANNING_RESULT_TYPES.find(option => option.value === planning_result_type);
        return option ? option : null;
    };

    onChange = (option?: SelectOptionItem) => {
        if (!option) {
            this.props.reduxDispatch({ type: RESET_FILTERS, data: undefined });
        } else {
            this.props.reduxDispatch({ type: SET_PLANNING_RESULT_TYPE, data: option.value });
        }
    };

    render() {
        return (
            <div className="order-filter">
                <Select
                    value={this.getSelectedOption(this.props.selected_planning_result_type)}
                    placeholder={translate("common.select_filter_value", "Select value")}
                    options={this.getOptions()}
                    onChange={this.onChange}
                    isSearchable={true}
                    isClearable
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 100 }),
                        menu: base => ({ ...base, width: "max-content", minWidth: "100%" }),
                    }}
                />
            </div>
        );
    }
}

const mapState = (state: ReduxState) => {
    const selected_planning_result_type = state.gantt_chart_filters.selected_planning_result_type;

    return {
        selected_planning_result_type,
    };
};
const mapDispatch = (dispatch: Dispatch<ActionTypes>) => ({
    reduxDispatch: dispatch,
});

type ReduxProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
export default connect<ReturnType<typeof mapState>, ReturnType<typeof mapDispatch>, OwnProps, ReduxState>(
    mapState,
    mapDispatch
)(PlanningResultFilter);
